// Gemeinsame Konstanten für das Abwesenheits-/Anwesenheits-Modul

export const ABSENCE_TYPES = ['Urlaub', 'Krankheit', 'Unbezahlter Urlaub', 'Schule', 'Sonstiges', 'Ersatz Geräte'];

// Badge-Styles (Listen/Tabellen)
export const TYPE_BADGE = {
  'Urlaub': 'bg-amber-100 text-amber-900 border-amber-200',
  'Krankheit': 'bg-emerald-100 text-emerald-900 border-emerald-200',
  'Unbezahlter Urlaub': 'bg-slate-200 text-slate-800 border-slate-300',
  'Schule': 'bg-violet-100 text-violet-900 border-violet-200',
  'Feiertag': 'bg-purple-100 text-purple-900 border-purple-200',
  'Sonstiges': 'bg-slate-100 text-slate-700 border-slate-200',
  'Ersatz Geräte': 'bg-orange-100 text-orange-900 border-orange-200',
};

// Balken-Styles (Timeline) – kräftige Vollfarben
export const TYPE_BAR = {
  'Urlaub': 'bg-amber-500 text-white',
  'Krankheit': 'bg-emerald-500 text-white',
  'Unbezahlter Urlaub': 'bg-slate-500 text-white',
  'Schule': 'bg-violet-500 text-white',
  'Feiertag': 'bg-purple-500 text-white',
  'Sonstiges': 'bg-slate-400 text-white',
  'Ersatz Geräte': 'bg-orange-500 text-white',
};

export const MONTHS_DE = [
  'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
  'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember',
];

export const WEEKDAYS_SHORT = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];

// hh:mm aus Dezimalstunden ("Std. min")
export function fmtHours(v) {
  if (v === null || v === undefined) return '—';
  const num = Number(v);
  if (Number.isNaN(num)) return '—';
  const h = Math.floor(num);
  const m = Math.round((num - h) * 60);
  return `${h}:${String(m).padStart(2, '0')}`;
}

export function fmtDays(v) {
  if (v === null || v === undefined) return '—';
  const num = Number(v);
  if (Number.isNaN(num)) return '—';
  return Number.isInteger(num) ? String(num) : num.toFixed(1);
}

export function monthKey(year, month0) {
  return `${year}-${String(month0 + 1).padStart(2, '0')}`;
}

export function monthRangeIso(year, month0) {
  const first = new Date(year, month0, 1);
  const last = new Date(year, month0 + 1, 0);
  const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  return { from: iso(first), to: iso(last), first, last, days: last.getDate() };
}
